import formatNumWithZero from './formatNumWithZero';

export default (date: Date): string => {
  const day = date.getDate();
  const month = date.getMonth() + 1;

  return `${formatNumWithZero(day)}.${formatNumWithZero(month)}.${date.getFullYear()}`;
};
